/* eslint-disable @typescript-eslint/no-var-requires */
export class AppInformationService {
	public getVersion(): string {
		return require('../../../package.json').version;
	}

	public getReleaseDate(): string {
		return require('../../../package.json').releaseDate;
	}
}
